import { render, staticRenderFns } from "./DashboardSellerBalance.vue?vue&type=template&id=3425df1e&"
import script from "./DashboardSellerBalance.vue?vue&type=script&lang=js&"
export * from "./DashboardSellerBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports